<template>
    <div>
        <div class="his-customers-list" style="display: flex">
            <el-radio-group v-model="radioValue">
                <div class="his-customers" v-for="item in payTypes.filter((item) => item.Pay_Type_ID == 1)" :key="item.Pay_Type_ID">
                    <el-radio :label="1">
                        <span>先款后货</span>
                    </el-radio>
                </div>
                <template v-if="!sub_customerInfor">
                    <div class="his-customers" v-for="item in payTypes.filter((item) => item.Pay_Type_ID == 3)" :key="item.Pay_Type_ID">
                        <el-radio :label="3">
                            <span>预付款</span>
                            <el-input v-model="valueOne" autocomplete="on" name="prepay_percent" clearable placeholder="" class="el-select-mini"></el-input>
                            %,货到
                            <el-input v-model="dateOne" autocomplete="on" name="nextpay_days" clearable placeholder="" class="el-select-mini"></el-input>
                            日内付清
                        </el-radio>
                    </div>
                </template>
                <div class="his-customers" v-for="item in payTypes.filter((item) => item.Pay_Type_ID == 4)" :key="item.Pay_Type_ID">
                    <el-radio :label="4">
                        <span>货到带款提货</span>
                    </el-radio>
                </div>
                <div class="his-customers" v-for="item in payTypes.filter((item) => item.Pay_Type_ID == 5)" :key="item.Pay_Type_ID">
                    <el-radio :label="5">
                        <span>货到按月结算</span>
                    </el-radio>
                </div>
                <div class="his-customers" v-for="item in payTypes.filter((item) => item.Pay_Type_ID == 6)" :key="item.Pay_Type_ID">
                    <el-radio :label="6">
                        <span>
                            需方通知发货, 货到
                            <el-input v-model="dateTwo" autocomplete="on" name="nextpay_days1" clearable placeholder="" :disabled="customerInfor.Customer_IsLimitPay == 1" class="el-select-mini"></el-input>
                            日内付清
                        </span>
                    </el-radio>
                </div>
                <div class="his-customers" v-for="item in payTypes.filter((item) => item.Pay_Type_ID == 7)" :key="item.Pay_Type_ID">
                    <el-radio :label="7">
                        <span>
                            先供底座，此货款发货后
                            <el-input v-model="dateFour" autocomplete="on" name="nextpay_days_7" clearable placeholder="" class="el-select-mini"></el-input>
                            日内付清；其他设备先款后货
                        </span>
                    </el-radio>
                </div>
                <div class="his-customers" v-for="item in payTypes.filter((item) => item.Pay_Type_ID == 8)" :key="item.Pay_Type_ID">
                    <el-radio :label="8">
                        <span>
                            预付款
                            <el-input v-model="valueFive" autocomplete="on" name="prepay_percent_8" clearable placeholder="" class="el-select-mini"></el-input>
                            % 货到
                            <el-input v-model="dateFive" autocomplete="on" name="nextpay_days_8" clearable placeholder="" class="el-select-mini"></el-input>
                            日内再付
                            <el-input v-model="valueSix" autocomplete="on" name="second_percent_8" clearable placeholder="" class="el-select-mini"></el-input>
                            % 调试验收后
                            <el-input v-model="dateSix" autocomplete="on" name="secondpay_days_8" clearable placeholder="" class="el-select-mini"></el-input>
                            日内付清所有余款， 如因非供方原因导致无法调试验收的，
                        </span>
                        <div style="padding: 8px 0px 8px 26px">
                            需方最迟在
                            <el-date-picker v-model="valueSeven" autocomplete="on" name="expired_date_8" type="date" placeholder="选择日期"></el-date-picker>
                            结清所有货款
                        </div>
                    </el-radio>
                </div>
                <div class="his-customers" v-for="item in payTypes.filter((item) => item.Pay_Type_ID == 9)" :key="item.Pay_Type_ID">
                    <el-radio :label="9">
                        <span>
                            预付款
                            <el-input v-model="endValueFive" autocomplete="on" name="prepay_percent_9" clearable placeholder="" class="el-select-mini"></el-input>
                            % 货到
                            <el-input v-model="endDateFive" autocomplete="on" name="nextpay_days_9" clearable placeholder="" class="el-select-mini"></el-input>
                            日内再付
                            <el-input v-model="endValueSix" autocomplete="on" name="second_percent_" clearable placeholder="" class="el-select-mini"></el-input>
                            % 调试验收后
                            <el-input v-model="endDateSix" autocomplete="on" name="secondpay_days_9" clearable placeholder="" class="el-select-mini"></el-input>
                            日内付合同总额的
                            <el-input v-model="endValueSeven" autocomplete="on" name="third_percent_9" clearable placeholder="" class="el-select-mini"></el-input>
                            %, 余
                            <el-input v-model="endValuEight" autocomplete="on" name="retention_percent_9" clearable placeholder="" class="el-select-mini"></el-input>
                            %质保金待
                        </span>
                        <div style="padding: 8px 0px 8px 26px">
                            质保期在满支付。因非供方原因导致无法调试验收的，需方最迟在
                            <el-date-picker autocomplete="on" name="expired_date_9" v-model="endValuNine" type="date" placeholder="选择日期"></el-date-picker>
                            日结清质保金以外的所有货款，（备注：带质保金的合同须总经理审批后签约）
                        </div>
                    </el-radio>
                </div>
                <div class="his-customers" v-for="item in payTypes.filter((item) => item.Pay_Type_ID == 2)" :key="item.Pay_Type_ID">
                    <el-radio :label="2">
                        <span>
                            其他
                            <el-input v-model="paytype_name" autocomplete="on" name="paytype_name" clearable placeholder="" :disabled="customerInfor.Customer_IsLimitPay == 1" class="el-select-mini"></el-input>

                            <span style="color: red">此付款方式仅能签订纸质合同、仅能审核订单后发货，申请发货需次次触发BPM发货审批流程，请谨慎选择。</span>
                        </span>
                    </el-radio>
                </div>
            </el-radio-group>
        </div>
    </div>
</template>
<script>
import { cloneDeep } from 'lodash';
export default {
    props: {
        customerInfor: {
            type: Object,
            default: () => {
                return {};
            }
        },
        resultInfo: {
            type: Object,
            default: () => {
                return {};
            }
        },
        isReturnGoods: {
            type: [Boolean, Number],
            default: 0
        },
        changePayInfoData: {
            type: Object,
            default: () => {
                return {};
            }
        },
        SPCApply_PayTypeID: {
            type: [String, Number],
            default: ''
        },
        SPCApply_PayTypeName: {
            type: String,
            default: ''
        },
        // 1临时报价单
        istemporary: {
            type: [String, Number],
            default: 0
        }
    },
    data() {
        return {
            temporary: false, //临时报价单标识
            radioValue: 1,
            valueOne: '', //预付款值
            dateOne: '', //预付款日期
            dateTwo: '', // 需方通知发货，货到几日内付清
            dateFour: '', //先供底座，此货款发货后
            valueFive: '', //预付款二值
            dateFive: '', //预付款二日期
            valueSix: '', //预付款二验收
            dateSix: '', //预付款二验收日期
            valueSeven: '', //预付款二结算日期
            endValueFive: '', //预付款三值
            endDateFive: '', //预付款三日期
            endValueSix: '', //预付款三验收
            endDateSix: '', //预付款三验收日期
            endValueSeven: '', //预付款三结算日期
            endValuEight: '', //预付款三值
            endValuNine: '', //预付款三值
            paytype_name: '', //支付方式为其它时
            payTypes: [],
            sub_customerInfor: '',

            needPayCode: {
                prepay_percent: '', // 预付比例	浮点型
                nextpay_days: '', //付款期
                second_percent: '', //  二期预付比例
                second_days: '', //  调试付款期
                third_percent: '', //  尾款比例
                retention_percent: '', // 剩余比例
                Expired_PayDate: '' // 最迟结算日期
            }
        };
    },
    mounted() {
        if (this.istemporary == 1) {
            this.radioValue = '';
        }
        this.getApiPayTypes(this.customerInfor);
        if (this.SPCApply_PayTypeID) {
            this.changePayInfo(this.SPCApply_PayTypeID);
        }
    },
    watch: {
        // 监听付款方式ID变化，用于返回步骤时回显选择状态
        SPCApply_PayTypeID: {
            handler(newVal) {
                if (newVal) {
                    this.changePayInfo(newVal);
                }
            },
            immediate: false
        },
        // 监听客户信息变化，重新获取付款方式列表
        customerInfor: {
            handler(newVal) {
                if (newVal && Object.keys(newVal).length > 0) {
                    this.getApiPayTypes(newVal);
                }
            },
            deep: true,
            immediate: false
        }
    },
    methods: {
        // 获取付款方式
        async getApiPayTypes(customerInfor) {
            const params = {
                TradeType: customerInfor.TradeType,
                Orders_type: customerInfor.Orders_type,
                Customer_Type: customerInfor.Customer_Type,
                Customer_IsLimitPay: customerInfor.Customer_IsLimitPay
                // Customer_Sub_ID:this.sub_customerInfor.Customer_Sub_ID||'',//子客户id
                // Customer_Name:this.customerInfor.Customer_Name,//客户名称
            };
            this.$newsApi.order.getApiPayTypes(params).then((res) => {
                if (res.data.Resultcode == 0) {
                    const Paymentlist = res.data.data;
                    this.payTypes = Paymentlist;
                }
            });
            if (this.isReturnGoods == 1 && this.resultInfo.SPCApply_PayTypeID) {
                this.payTypes = this.payTypes.filter((item) => item.Pay_Type_ID == this.resultInfo.SPCApply_PayTypeID);
            }
            if (this.customerInfor.Customer_IsLimitPay == 1) {
                this.dateTwo = this.customerInfor.Customer_LimitPayDebtMaxDays;
            }
        },
        //重置支付参数
        resetPayCode() {
            for (var key in this.needPayCode) {
                this.needPayCode[key] = '';
            }
        }, 
        // 检查付款方式
        async checkApiPayTypes(e) {
            var json = JSON.stringify(e) || '';
            var result = await this.$newsApi.order.getCheckPayTypes({
                PayTypeID: this.radioValue,
                json: json
            });
            return result.data;
        },
        async nextStep() {
            this.resetPayCode();
            // console.log(this.radioValue);
            if (this.radioValue != '') {
                let result = '';
                let radioValue = Number(this.radioValue);
                radioValue = this.radioValue == 10 ? 0 : this.radioValue;
                switch (radioValue) {
                    case 1:
                        this.needPayCode.prepay_percent = 100;
                        this.needPayCode.nextpay_days = 0;
                        break;
                    case 2:
                        result = { paytype_name: this.paytype_name };
                        this.needPayCode.prepay_percent = 100;
                        this.needPayCode.nextpay_days = 0;
                        break;
                    case 3:
                        result = { prepay_percent: this.valueOne, nextpay_days: this.dateOne };
                        this.needPayCode.prepay_percent = this.valueOne;
                        this.needPayCode.nextpay_days =  this.dateOne;
                        break;
                    case 4:
                        break;
                    case 5:
                        break;
                    case 6:
                        result = { nextpay_days1: this.dateTwo };
                        this.needPayCode.nextpay_days = this.dateTwo;
                        break;
                    case 7:
                        result = { nextpay_days_7: this.dateFour };
                        this.needPayCode.prepay_percent = 100;
                        this.needPayCode.nextpay_days = this.dateFour;
                        break;
                    case 8:
                        result = {
                            prepay_percent_8: this.valueFive,
                            nextpay_days_8: this.dateFive,
                            second_percent_8: this.valueSix,
                            secondpay_days_8: this.dateSix,
                            expired_date_8: this.valueSeven
                        };
                        this.needPayCode.prepay_percent = this.valueFive;
                        this.needPayCode.nextpay_days = this.dateFive;
                        this.needPayCode.second_percent = this.valueSix;
                        this.needPayCode.secondpay_days = this.dateSix;
                        this.needPayCode.Expired_PayDate = this.valueSeven;
                        break;
                    case 9:
                        result = {
                            prepay_percent_9: this.endValueFive,
                            nextpay_days_9: this.endDateFive,
                            second_percent_9: this.endValueSix,
                            secondpay_days_9: this.endDateSix,
                            third_percent_9: this.endValueSeven,
                            retention_percent_9: this.endValuEight,
                            expired_date_9: this.endValuNine
                        };
                        this.needPayCode.prepay_percent = this.endValueFive;
                        this.needPayCode.nextpay_days = this.endDateFive;
                        this.needPayCode.second_percent = this.endValueSix;
                        this.needPayCode.secondpay_days = this.endDateSix;
                        this.needPayCode.third_percent = this.endValueSeven;
                        this.needPayCode.retention_percent = this.endValuEight;
                        this.needPayCode.Expired_PayDate = this.endValuNine;
                        break;
                }
                var submit = await this.checkApiPayTypes(result);
                if (submit.resultcode == 0) {
                    let submitpaymentObj = {
                        id: this.radioValue,
                        value: submit.resultinfo,
                        needPayCode: this.needPayCode
                    };
                    return submitpaymentObj;
                } else {
                    return false;
                }
            } 
        },
        // 初始化合同修改购物车商品
        async ClearSPCOrdersGoodsTmpByOrdersID(e) {
            var result = await this.$newsApi.order.ClearSPCOrdersGoodsTmpByOrdersID({
                OrdersID: e.Orders_ID,
                TradeType: 2,
                Orders_Type: e.orderType
            });
        },
        //回显支付选择方式
        changePayInfo(e) {
            e = Number(e);
            this.radioValue = e;
            let result = this.changePayInfoData;
            switch (e) {
                case 1:
                    break;
                case 2:
                    this.paytype_name = this.SPCApply_PayTypeName || '';
                    break;
                case 3:
                    this.valueOne = result.prepay_percent;
                    this.dateOne = result.nextpay_days;
                    this.needPayCode.prepay_percent = this.valueOne;
                    this.needPayCode.nextpay_days = this.dateOne;
                    break;
                case 4:
                    break;
                case 5:
                    break;
                case 6:
                    this.customerInfor.Customer_IsLimitPay == 1 ? (this.dateTwo = this.customerInfor.Customer_LimitPayDebtMaxDays) : (this.dateTwo = result.nextpay_days);
                    this.needPayCode.nextpay_days = this.dateTwo;
                    break;
                case 7:
                    this.dateFour = result.nextpay_days;
                    this.needPayCode.nextpay_days = this.dateFour;
                    break;
                case 8:
                    this.valueFive = result.prepay_percent;
                    this.dateFive = result.nextpay_days;
                    this.valueSix = result.second_percent;
                    this.dateSix = result.second_days;
                    this.valueSeven = result.Expired_PayDate;
                    this.needPayCode.prepay_percent = this.valueFive;
                    this.needPayCode.nextpay_days = this.dateFive;
                    this.needPayCode.second_percent = this.valueSix;
                    this.needPayCode.secondpay_days = this.dateSix;
                    this.needPayCode.expired_date = this.valueSeven;
                    break;
                case 9:
                    this.endValueFive = result.prepay_percent;
                    this.endDateFive = result.nextpay_days;
                    this.endValueSix = result.second_percent;
                    this.endDateSix = result.second_days;
                    this.endValuNine = result.Expired_PayDate;
                    this.endValuEight = result.retention_percent;
                    this.endValueSeven = result.third_percent;
                    this.needPayCode.prepay_percent = this.endValueFive;
                    this.needPayCode.nextpay_days = this.endDateFive;
                    this.needPayCode.second_percent = this.endValueSix;
                    this.needPayCode.secondpay_days = this.endDateSix;
                    this.needPayCode.third_percent = this.endValueSeven;
                    this.needPayCode.retention_percent = this.endValuEight;
                    this.needPayCode.Expired_PayDate = this.endValuNine;
                    break;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.his-customers-list {
    margin-top: 20px;
}
.his-customers {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    min-height: 40px;
    line-height: 40px;
}
</style>
